const INVITATION_STORAGE_KEY = 'pendingInvitation';

export const InvitationUtils = {
    storeInvitation: (invitationData) => {
        try {
            localStorage.setItem(INVITATION_STORAGE_KEY, JSON.stringify(invitationData));
            return true;
        } catch (error) {
            console.error('Failed to store invitation:', error);
            return false;
        }
    },

    getStoredInvitation: () => {
        try {
            const stored = localStorage.getItem(INVITATION_STORAGE_KEY);
            return stored ? JSON.parse(stored) : null;
        } catch (error) {
            console.error('Failed to retrieve invitation:', error);
            return null;
        }
    },

    clearInvitation: () => {
        try {
            localStorage.removeItem(INVITATION_STORAGE_KEY);
            return true;
        } catch (error) {
            console.error('Failed to clear invitation:', error);
            return false;
        }
    }
};